import { GIMRoles } from "../../types/shared/RA-types";

const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const ISSUER = process.env.REACT_APP_OKTA_ISSUER;
const HOST = window.location.host;
export const REDIRECT_URI = HOST === 'localhost:3000' ? `http://${HOST}` : `https://${HOST}`;
export const DEFAULT_SCOPES =  ['openid', 'email', 'profile', 'customerType', 'driverType'];
const CUSTOMER_ADMIN_SCOPES = ['customer:read', 'customer:update', 'customer:create', 'customer:delete', 'customer:test'];
const DRIVER_ADMIN_SCOPES = ['driver:read', 'driver:update', 'driver:create', 'driver:delete', 'driver:test'];
const DRIVER_READ_ONLY_SCOPES = ['driver:read']
const CS_SCOPES = ['customer:read', 'customer:update', 'customer:create'];
const DS_SCOPES = ['driver:read', 'driver:update', 'driver:create'];
///const QA_SCOPES = ['customer:read', 'customer:create', 'driver:read', 'driver:create']

export function getScopes(customerRoles: string[], driverRoles: string[]):string[] {
  let scopes:string[] = [];
  if(customerRoles){
    customerRoles.map(role => {
      switch (role) {
      case GIMRoles.Admin:
        scopes = [...scopes, ...CUSTOMER_ADMIN_SCOPES];
        break;
      case GIMRoles.Support:
        scopes = [...scopes, ...CS_SCOPES];
        break;
      case GIMRoles.Engineer:
        scopes = [...scopes, 'customer:test'];
        break;
      default:
        break;
      }
    })
  }
  if(driverRoles){
    driverRoles.map(role => {
      switch (role) {
      case GIMRoles.Admin:
        scopes = [...scopes, ...DRIVER_ADMIN_SCOPES];
        break;
      case GIMRoles.Support:
        scopes = [...scopes, ...DS_SCOPES];
        break;
      case GIMRoles.SupportTier2:
        scopes = [...scopes, ...DS_SCOPES];
        break;
      case GIMRoles.Compliance:
        scopes = [...scopes, ...DS_SCOPES];
        break;
      case GIMRoles.Engineer:
        scopes = [...scopes, 'driver:test'];
        break;
      case GIMRoles.ReadOnly:
        scopes = [...scopes, ...DRIVER_READ_ONLY_SCOPES]
        break
      default:
        break;
      }
    })
  }
  return scopes;
}



export const config = {
  issuer: ISSUER,
  clientId: CLIENT_ID,
  //clientSecret: CLIENT_SECRET,
  redirectUri: REDIRECT_URI,
  //responseMode: 'fragment',
  responseType: ['id_token', 'code', 'token'],
  pkce: false,
  tokenManager: {
    storage: 'sessionStorage'
  },
  scopes: DEFAULT_SCOPES
};
